





























import flagKeys from '@/constants/flagKeys';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class SpecialCoinIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly fill?: string;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get newIconCoinFlag() {
    return this.flags.includes(flagKeys.newCoinIcon);
  }
}
